const AMBEV_DOMAINS = [
    '@ambev.com',
    '@ambev.com.br',
    '@ambevtech.com',
    '@ambevtech.com.br',
    '@ab-inbev.com',
    '@gmodelo.com.mx',
    '@service-account-ambevtech.com.br',
];

export default AMBEV_DOMAINS;
